import { type PropsWithChildren } from 'react';

import posthog, { type PostHogConfig } from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';

const options: Partial<PostHogConfig> = {
  api_host: 'https://eu.i.posthog.com',
  defaults: '2026-01-30',
  persistence: 'localStorage',
};

const POSTHOG_API_KEY = import.meta.env.VITE_POSTHOG_API_KEY;

if (typeof window !== 'undefined') {
  posthog.init(POSTHOG_API_KEY, options);
}

export default function PostHogProvider({ children }: PropsWithChildren) {
  if (!POSTHOG_API_KEY) return children;

  return <PHProvider client={posthog}>{children}</PHProvider>;
}
